export const ScenariosData = {
  fields: [
    {
      key: "name",
      label: "",
      sortable: false,
      class: "table-data-description"
    },
    {
      key: "stressed",
      label: "Stress",
      sortable: false,
      class: "table-data-value"
    },
    {
      key: "unfavorable",
      label: "Sfavorevole",
      sortable: false,
      class: "table-data-value"
    },
    {
      key: "moderate",
      label: "Moderato",
      sortable: false,
      class: "table-data-value"
    },
    {
      key: "favorable",
      label: "Favorevole",
      sortable: false,
      class: "table-data-value"
    }
  ],
  data: [
    {
      name: "Valore del contratto al termine del periodo di simulazione",
      stressed: "0",
      unfavorable: "0",
      moderate: "0",
      favorable: "0"
    },
    {
      name: "Capitale in caso di decesso",
      stressed: "0",
      unfavorable: "0",
      moderate: "0",
      favorable: "0"
    },
    {
      name: "Riscatto",
      stressed: "0",
      unfavorable: "0",
      moderate: "0",
      favorable: "0"
    }
  ]
};
